import dropdownInput from "./dropdown-input";

function debounce(delay, callback) {
    let timerId;
    return function(...args) {
        if (timerId) {
            clearTimeout(timerId);
            timerId = setTimeout(() => {
                timerId = null;
                callback(...args);
            }, delay);
        } else {
            callback(...args);
            timerId = setTimeout(() => {
                timerId = null;
            }, delay);
        }
    }
}
export default new class {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
        this.debounceFunc = debounce(500, (form,data = {}) => {
            oc.request(form, form.dataset.handler, {
                data,
                update: {
                    'search-main/search-main-results': '#search-main-results'
                },
                complete: () => {
                    
                }
            })
        });
        this.lastValue = '';
    }

    init() {
        const form = this.getForm();
        form.addEventListener('keyup', e => {
            const input = e.target.closest('#search-main')
            if (input && input.value != this.lastValue) {
                this.lastValue = input.value
                this.onSearch();
            }
        })

        form.addEventListener('change', (e) => {
            if (e.target.type == "radio") {
                this.onSearch();
            }
        })

        document.body.addEventListener('click', (e) => {
            if (e.target.closest('#search-main-results [data-search-type]')) {
                e.preventDefault();
                const input = this.getForm().querySelector(`[name="search_by"][value="${e.target.dataset.searchType}"]`);
                input.checked = true;
                dropdownInput.renderRadio(input);
                this.onSearch();
            }
        })
    }

    onSearch() {
        const searchInput = document.querySelector('#search-main');
        if (searchInput.value.length) {
            document.querySelector('#popup-search.popup').classList.add('popup_show-results');
            this.debounceFunc(searchInput.form);
        } else {
            document.querySelector('#popup-search.popup').classList.remove('popup_show-results');
        }
    }

    getForm() {
        return document.querySelector('.search-form-main')
    }
}